import { GET_PACKAGES } from './reducer';

export const getPackages = (data) => ({
  type: GET_PACKAGES,
  payload:data
});
